import { X } from 'lucide-react';

import { ModalShell } from './modal';
import { BaseModalProps } from '../model';

const BaseModal: React.FC<BaseModalProps> = ({
  modalData,
  labels,
  onClose,
  onConfirm,
  isLoading = false,
}) => {
  if (!modalData) {
    return null;
  }

  return (
    <ModalShell
      isOpen={Boolean(modalData)}
      onClose={onClose}
      ariaLabel={labels.title}
      panelClassName="w-full max-w-md overflow-hidden"
    >
      <div className="flex items-start justify-between gap-4 px-6 py-4 border-b border-neutral-200 dark:border-neutral-800">
        <h2 className="text-base font-semibold text-neutral-900 dark:text-white">
          {labels.title}
        </h2>
        <button
          type="button"
          onClick={onClose}
          className="w-8 h-8 flex items-center justify-center rounded-lg text-neutral-600 dark:text-neutral-400 hover:bg-neutral-100 dark:hover:bg-neutral-900 transition-colors"
          aria-label="Close"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
      <div className="px-6 py-5">
        <p className="text-sm text-neutral-700 dark:text-neutral-300 mb-6">
          {labels.content}
        </p>
        <div className="flex justify-end gap-3">
          <button
            type="button"
            onClick={onClose}
            disabled={isLoading}
            className="btn-secondary"
          >
            {labels.cancelLabel}
          </button>
          <button
            type="button"
            disabled={isLoading}
            onClick={onConfirm}
            className="btn-primary disabled:bg-brand-300 disabled:cursor-not-allowed"
          >
            {labels.confirmLabel}
          </button>
        </div>
      </div>
    </ModalShell>
  );
};

export default BaseModal;
